import { render, staticRenderFns } from "./DetailPatent.vue?vue&type=template&id=f6f36c0e&scoped=true&"
import script from "./DetailPatent.vue?vue&type=script&lang=ts&"
export * from "./DetailPatent.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPatent.vue?vue&type=style&index=0&id=f6f36c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f36c0e",
  null
  
)

export default component.exports